module.exports = __webpack_public_path__ + "static/media/page_loading_icon.18b27449.svg";